import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Avatar from './Avatar';

export default class EditableAvatar extends Component {
  static propTypes = {
    avatar_url: PropTypes.string,
    entity_type: PropTypes.string.isRequired,
    name: PropTypes.string,
    uploaderCopy: PropTypes.string,
    triggerEvents: PropTypes.bool,
    containerClasses: PropTypes.string,
  }

  static defaultProps = {
    containerClasses: 'u-text-center u-mb-8',
    uploaderCopy: null,
    triggerEvents: false,
    avatar_url: '',
    name: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      avatar_url: this.props.avatar_url,
      triggerEvents: false,
    };
  }

  openInput = () => {
    this.refs.fileInput.click();
  }

  changeAvatar = (evnt) => {
    const input = evnt.target;

    if (input.files && input.files[0]) {
      const self = this;
      const reader = new FileReader();
      const dataUrl = input.files[0];

      reader.onload = function (e) {
        self.setState({
          avatar_url: e.target.result,
          data_uri: e.target.result,
        });
      };

      reader.readAsDataURL(dataUrl);
      this.triggerCustomEvent(dataUrl);
    }
  }

  // In the views you can listen to the custom event. You should use a parent
  // element if you want to bind before the react component is mounted.
  triggerCustomEvent(value) {
    if (this.props.triggerEvents) {
      const $node = $(ReactDOM.findDOMNode(this));
      $node.trigger('editableavatar:change', [value]);
    }
  }

  render() {
    return (
      <div onClick={this.openInput} className={this.props.containerClasses}>
        { this.state.avatar_url &&
          <Avatar
            className="Form-avatarUploader Avatar--editable"
            name={this.props.name}
            src={this.state.avatar_url}
            showInitials
            type={this.props.entity_type}
          />
        }
        { !this.state.avatar_url &&
          <div className="u-cursor-pointer u-border u-border-dashed u-bg-grey-lightest u-rounded u-px-2 u-py-2 u-inline-flex u-flex-col u-justify-center u-items-center u-w-36 u-h-36">
            <span className="u-border u-w-12 u-h-12 u-flex u-justify-center u-items-center u-rounded-full u-mb-4">
              <i className="Icon Icon-camera u-text-black u-text-lg u-mr-0" />
            </span>
            <span className="u-text-sm u-text-black u-font-semibold">
              { this.props.uploaderCopy === null ? 'Add your logo' : this.props.uploaderCopy }
            </span>
            <span className="u-text-xs u-text-grey u-italic">Select a file <br/>(max . 20 mb)</span>
          </div>
        }
        <input
          style={{ display: 'none' }}
          onChange={this.changeAvatar}
          ref="fileInput"
          type="file"
          name={`${this.props.entity_type}[avatar]`}
        />
      </div>
    );
  }
}
